// extracted by mini-css-extract-plugin
export default {"tag":"tag__ab6ml"};